module.exports = __webpack_public_path__ + "static/media/coursebg1.776bae65.png";